import { render } from "./MetaCampaigns.vue?vue&type=template&id=5b36a25c"
import script from "./MetaCampaigns.vue?vue&type=script&lang=js"
export * from "./MetaCampaigns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__